module.exports = __webpack_public_path__ + "img/hubla.2e5df153.svg";